import { createStore, applyMiddleware, compose } from 'redux';
import { persistState } from 'redux-devtools';
import {createLogger} from 'redux-logger';

import rootReducer from '../reducers';

export default function configureStore(initialState) {

  let enhancer;
  let middleware;

  if (process.env.NODE_ENV !== 'production') {

    middleware = applyMiddleware(createLogger());

    let getDebugSessionKey = function () {
      // By default we try to read the key from ?debug_session=<key> in the address bar
      const matches = window.location.href.match(/[?&]debug_session=([^&]+)\b/);
      return (matches && matches.length) ? matches[1] : null;
    };

    enhancer = compose(

      // Middleware we want to use in development
      middleware,
      window.devToolsExtension ?
        window.devToolsExtension() :
        require('../containers/DevTools').default.instrument(),

      // Optional. Lets you write ?debug_session=<key> in address bar to persist debug sessions
      persistState(getDebugSessionKey())
    );
  } else {
    enhancer = compose(middleware);
  }

  const store = createStore(rootReducer, initialState, enhancer);

  // Enable Webpack hot module replacement for reducers
  if (module.hot) {
    module.hot.accept('../reducers', () =>
      store.replaceReducer(require('../reducers').default)
    );
  }

  return store;
}



/** WEBPACK FOOTER **
 ** ./src/js/store/configureStore.js
 **/